import {useState} from 'react';
import useUser from '../../hooks/useUser';
import { useToast } from '../../admin/components/Toast';
const ForgotPasswordPage = () => {
    const { RequestPasswordReset } = useUser();
    const [email, setEmail] = useState("");
    const { addToast } = useToast();
    
    const handleForgotPassword = async (e) => {
        e.preventDefault();
        try {
            await RequestPasswordReset(email);
                  addToast("Password reset email sent successfully.", "success");

        } catch (error) {
            console.log("error while requesting password reset", error);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-16 p-6 border border-gray-300 bg-white rounded shadow">
            <form className="space-y-4">
                <label>
                    Email:
                    <input type="email" name="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                </label>
                <button className='w-full py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700' onClick={handleForgotPassword} type="submit">Request Password Reset</button>
            </form>
        </div>
    );
};

export default ForgotPasswordPage;
